<mbs-modal
  [title]="(destination ? 'shared:modals.addDestinationBucket.edit' : 'shared:modals.addDestinationBucket.create') | i18next"
  [attr.data-e2e]="'add-destination-modal'"
  [isCustomModal]="true"
  [loading]="loading"
  #modal>
  <ng-container modal-body>
    <ng-container *ngIf="destination?.isReadOnly">
      <mbs-alert
        [type]="popupType.warning"
        [icon]="true">
        {{ 'shared:modals.addDestinationBucket.insufficientPermissionsToEditDestination' | i18next }}
      </mbs-alert>
    </ng-container>

    <mbs-alert
      *ngIf="errorText"
      [type]="popupType.danger"
      [icon]="true">
      {{ errorText }}
    </mbs-alert>

    <mbs-add-destination-alternate-form
      [form]="form"
      [destination]="destination"
      [storageAccount]="storageAccount">
    </mbs-add-destination-alternate-form>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      [attr.data-e2e]="'save-btn'"
      [disabled]="destination?.isReadOnly"
      (click)="onActionButtonClick()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>

    <mbs-button
      [type]="'secondary'"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
